import React from 'react';

import ResourceList from '../ResourceSchedule/ResourceList';
import userAxis from './userAxis';
import { useUserRowMap } from './useUserRows';

export default function UserList(props) {
  const rowMap = useUserRowMap();
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <ResourceList axis={userAxis} rowMap={rowMap} {...props} />
  );
}
